import React from "react";
import { Popover } from "../Utils/Popover";
import { Audit } from '../Icons/Icons';
import { Diff } from '../Utils/Diff';
import { extractContentFromHTML, shiftAuditDateMonth } from "../Utils/Formatter";
import "../../assets/sass/lbd/_audit.scss";
import { useTranslation } from "react-i18next";

export const AuditTooltip = (props) => {
    const { t } = useTranslation();

    const oldText = shiftAuditDateMonth(extractContentFromHTML((props.text.old ?? "").toString()));
    const currentText = shiftAuditDateMonth(extractContentFromHTML((props.text.current ?? "").toString()));

    const diffComponent = <Diff inputA={oldText} inputB={currentText} type="words" />;
    return (
        <Popover
            id={`audit-tooltip-${props.id}`}
            title={t("auditTrail.lastChanges")}
            popover={diffComponent}
        >
            <Audit style={{ fontSize: '25px', color: '#50ABB5', cursor: 'hand' }} />
        </Popover>
    );
}